module.exports = __webpack_public_path__ + "static/img/v2.df6560d.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/v2.png
// module id = 3R1Q
// module chunks = 1